// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","ham_body":"Logo_ham_body__vG95B"};